/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by generateAwsExports.ts
// Generated at: 2026-06-18T10:30:01.500Z

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:a0ccbbe2-aeeb-47b7-a8ed-dc6dc76f4197",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_x6RQobbzD",
    "aws_user_pools_web_client_id": "729c5210ma4tns4g9r9qm4p6th",
    "oauth": {
        "domain": "quicktrip-evalfujia.auth.ap-northeast-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://eval-fuji-a.lecip-r05-dev.net/",
        "redirectSignOut": "https://eval-fuji-a.lecip-r05-dev.net/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_NUMBERS",
            "REQUIRES_UPPERCASE",
            "REQUIRES_LOWERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "quicktrip-hosting-evalfujia",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "https://d1kksbca7egi6o.cloudfront.net"
};

export default awsmobile;
